<template>
    <main-content>
        <Card></Card>
    </main-content>
</template>

<script>
    import Card from './components/card.vue';
    import MainContent from "@/components/main-content";

    export default {
        components: {
            Card,
            MainContent,
        },
    };
</script>